<template>
  <div
    v-click-outside="closeDropdown"
    class="button-dropdown"
  >
    <button
      :class="{ 'btn-icon': icon }"
      @click="toggleDropdown"
    >
      <md-icon
        v-if="icon"
        :md-src="'/static/images/' + icon + '.svg'"
        class="icon-download"
      />

      <span>
        {{ selectedOption }}
      </span>
    </button>
    <ul
      v-if="isOpen"
      class="button-dropdown__menu"
    >
      <li
        v-for="option in options"
        :key="option"
        @click="selectOption(option)"
      >
        <md-icon
          v-if="option.icon"
          :md-src="option.icon"
          class="md-icon"
        />
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>

<script>
import { clickOutside } from '@/utils/directives'

export default {
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    },
    clickOutside
  },
  props: {
    initialOptions: {
      type: Array,
      required: true
    },
    itMayChangeSelectedOption: {
      type: Boolean,
      default: true
    },
    selectedOption: {
      type: String,
      default: 'Selecione uma opção'
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: false,
      options: []
    }
  },
  mounted() {
    this.options = this.initialOptions
  },
  methods: {
    closeDropdown() {
      this.isOpen = false
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    selectOption(option) {
      if (this.itMayChangeSelectedOption) {
        this.selectedOption = option
      }

      this.isOpen = false
      this.$emit('option-selected', option)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-dropdown {
  position: relative;
  display: inline-block;

  button {
    background: none;
  }

  &__menu {
    position: absolute;
    background-color: #fff;
    right: 0; 
    border: 0px solid #ced4da;
    padding: 5px 0;
    margin-top: 5px;
    list-style: none;
    width: 212px;
    z-index: 1040;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    li {
      padding: 10px 15px;
      cursor: pointer;

      &:hover {
        background-color: #f8f9fa;
      }
    }
  }

  button {
    width: 100%;
    font-weight: 500;
    text-transform: uppercase;
    font-family: 'Exo 2', sans-serif !important;
    padding: 10px 15px;
    cursor: pointer;
    color: #fff;

    span {
      font-weight: 600;
    }

    &.btn-icon {
      display: flex;
      justify-content: center;
      align-items: center;

      .md-icon {
        width: 15px;
        min-width: 15px;
        height: 15px;
        min-height: 15px;
        margin: 0;
        margin-right: 8px;
      }
    }
  }
}
</style>
